import type { TranslationDict } from './ja'

export const ptBR: TranslationDict = {
  appTitle: 'Lucky Animal Territory',
  help: 'Como jogar',
  helpAria: 'Como jogar',
  settings: 'Configurações',
  settingsAria: 'Configurações',
  close: 'Fechar',
  closeAria: 'Fechar',
  player: 'Jogador',
  highscore: 'Recorde',
  start: 'Começar',
  staminaEmpty: 'Energia insuficiente',
  ranking: 'Batalha de Território',
  difficultyTitle: 'Escolha a dificuldade',
  difficultyStart: 'Começar nesta dificuldade',
  back: 'Voltar',
  today: 'Hoje',
  weekly: 'Esta semana',
  alltime: 'Geral',
  loading: 'Carregando...',
  noScores: 'Ainda não há resultados. Seja o primeiro campeão!',
  loadFailed: 'Falha ao carregar',
  you: 'Você',
  youConstant: 'VOCÊ',
  language: 'Idioma',
  languageNote: 'Compatível com 18 idiomas, incluindo japonês.',
  bgm: 'BGM',
  se: 'Efeitos',
  soundEnableAria: 'Ativar som',
  soundDisableAria: 'Desativar som',
  adWatch: 'Ver anúncio até o fim',
  adCancel: 'Agora não',
  rankSuffix: 'º',
  earnedPoints: 'ganhou {score} pts',
  helpGoalTitle: '🎯 Objetivo',
  helpGoalText: 'Coloque peças no tabuleiro 9x9 e expanda seus territórios conectados. Vence quem tiver a maior pontuação.',
  helpWinTitle: '🏆 Condições de vitória',
  helpWinFive: 'Faça cinco em linha vertical, horizontal ou diagonalmente para uma vitória instantânea.',
  helpWinScore: 'Se o tabuleiro encher, a pontuação mais alta vence. Não há empates.',
  helpScoreTitle: '💯 Pontuação',
  helpLineBonus: 'Bônus de linha: ganhe pontos por linhas de 3, 4 e 5 em linha.',
  helpClusterBonus: 'Bônus de território: pontue mais à medida que seus grupos conectados crescem.',
  helpKomi: 'Komi: o segundo jogador recebe um bônus de pontuação de +10%.',
  helpControlsTitle: '🖱️ Controles',
  helpControlsText: 'Na sua vez, toque em uma célula vazia para colocar uma peça.',
  helpTipsTitle: '💡 Dicas',
  helpTipHell: 'Tente o modo HELL quando quiser o maior desafio.',
  helpTipCluster: 'Não busque apenas o cinco em linha. Grupos conectados maiores também aumentam sua pontuação.',
  resultWinFive: '🎉 Cinco em linha! Você venceu!',
  resultWinScore: '🎉 Vitória por pontos! Você venceu!',
  resultLoseFive: '😿 O CPU fez cinco em linha!',
  resultLoseScore: '😿 Derrota por pontos. Tente novamente!',
  resultDraw: '🤝 Empate',
  newHighscore: '🏆 Novo recorde!',
  scoreNone: 'Sem pontuação',
  clusterBonus: 'Bônus de território',
  retry: 'Jogar novamente',
  titleBack: 'Título',
  scoreHintPlaceStone: 'Coloque uma peça',
  best: 'Melhor',
  clusterUnit: 'território',
  lineCount: '{len} em linha x{count}',
  turnCount: 'Jogada {count} · {difficulty}',
  boardPlayerPiece: 'Sua peça',
  boardCpuPiece: 'Peça do CPU',
  boardPlayerAlt: 'Você',
  boardCpuAlt: 'CPU',
  boardCellPosition: 'linha {row}, coluna {col}',
  boardPlaceable: 'colocável',
  boardEmpty: 'célula vazia',
  boardFlower: 'tem flor',
  firstPlayerAlt: 'Primeiro jogador',
  playerFirst: 'Você começa!',
  playerSecond: 'Você joga em segundo (+{bonus}% komi)',
  cpuFirst: 'O CPU começa!',
  finalePlayerWin: 'Você venceu!',
  finaleCpuWin: 'CPU venceu!',
  finaleFive: 'Cinco em linha!',
  finaleTerritory: 'Batalha de territórios!',
  winnerAlt: 'Vencedor',
  loadingBoot: 'Iniciando...',
  loadingConnect: 'Conectando...',
  loadingProfile: 'Carregando perfil...',
  loadingAssets: 'Carregando recursos...',
  loadingReady: 'Pronto',
  reauthRequiredTitle: 'Login necessário',
  startupFailedTitle: 'Falha ao iniciar',
  reauthButton: 'Fazer login novamente',
  reloadButton: 'Recarregar',
  lineReloginButton: 'Login LINE',
  reauthReason: 'Sua sessão expirou. Por favor, faça login novamente.',
  errorReauth: 'Sua sessão expirou. Por favor, faça login novamente.',
  errorForbidden: 'Você não tem permissão para usar este jogo.',
  errorNotFound: 'Dados do jogo não encontrados.',
  errorRateLimited: 'A rede está ocupada. Por favor, aguarde e tente novamente.',
  errorServer: 'Não foi possível conectar ao servidor. Por favor, aguarde e recarregue.',
  errorCommunication: 'Ocorreu um erro de comunicação. Por favor, recarregue.',
  errorNetwork: 'Não foi possível conectar à rede. Verifique sua conexão e recarregue.',
  errorStartup: 'Falha ao iniciar. Por favor, recarregue.',
  settingsTabGeneral: 'Configurações',
  settingsTabAccount: 'Conta',
  settingsTabInfo: 'Info',
  account: 'Conta',
  linked: 'Vinculado',
  guest: 'Visitante',
  loggedInWith: 'Logado com {provider}',
  loggedIn: 'Logado',
  playingAsGuest: 'Você está jogando como visitante.',
  appleLoginBusy: 'Logando com Apple...',
  appleLogin: 'Entrar com Apple',
  googleLoginBusy: 'Logando com Google...',
  googleLogin: 'Entrar com Google',
  logoutBusy: 'Saindo...',
  logout: 'Sair',
  logoutSuccess: 'Deslogado',
  logoutFailed: 'Falha ao sair',
  appInfo: 'Informações do app',
  appName: 'Nome do app',
  version: 'Versão',
  legalInfo: 'Informações legais',
  terms: 'Termos de Uso',
  privacy: 'Política de Privacidade',
  operator: 'Operador',
  contact: 'Contato',
  copyTap: 'Toque para copiar',
  idCopied: 'ID copiado',
  copyFailed: 'Falha ao copiar',
  other: 'Outro',
  reportAd: 'Reportar anúncio impróprio',
  privacyChoices: 'Ad privacy choices',
  profileEdit: 'Editar perfil',
  displayName: 'Nome de exibição',
  displayNamePlaceholder: 'Digite um nome',
  chooseIcon: 'Escolher ícone',
  iconLoadFailed: 'Falha ao carregar ícones.',
  saveFailed: 'Falha ao salvar. Tente novamente.',
  noIcons: 'Nenhum ícone disponível.',
  save: 'Salvar',
  saving: 'Salvando...',
  staminaAria: 'Energia {stamina} / {max}',
  nextRecovery: 'Próxima recuperação em {time}',
  adPlaying: 'Exibindo anúncio...',
  recoverFullAd: 'Ver anúncio para recuperar toda a stamina',
  dailyBonusAria: 'Ver anúncio até o fim para ganhar +5 stamina',
  dailyBonusAd: 'Ver anúncio para ganhar +5 stamina',
  legalLastUpdated: 'Última atualização: {date}',
  privacyTitle: 'Política de Privacidade',
  termsTitle: 'Termos de Uso',
  adPlayingAria: 'Anúncio em exibição',
  adBadge: '▶ Anúncio',
  adRemaining: 'Restam {seconds}s',
  adDevHint: 'Anúncio de teste. Em produção, um vídeo do AdMob será exibido.',
  adRewardRequirement: 'Veja o anúncio até o fim para receber esta recompensa.',
  adRewardStaminaDetail: 'Recompensa: stamina restaurada até o máximo',
  adRewardDailyBonusDetail: 'Recompensa: +{amount} stamina como bônus diário',
  adRewardIncompleteNote: 'Se fechar antes do fim, você não receberá a recompensa.',
  adSkipAria: 'Pular anúncio',
  adSkip: 'Pular ✕',
  adSkipAfter: 'Pular em {seconds}s',
  offlineMessage: 'Não foi possível conectar ao servidor. Algumas funções podem estar indisponíveis.',
  reconnecting: 'Reconectando...',
  reconnect: 'Reconectar',
  signInTitle: 'Entrar',
  signInBusy: 'Entrando...',
  signInCancelNote: 'Se cancelar, você pode continuar como visitante (algumas funções indisponíveis).',
  processing: 'Processando...',
  recoverConfirmTitle: 'Confirmar substituição de dados',
  recoverConfirmMessage: 'Já existem dados vinculados a este login. Continuar substituirá os dados de visitante neste dispositivo. Deseja continuar?',
  recoverConfirmContinue: 'Restaurar',
  recoverConfirmCancel: 'Cancelar',
  unlinkConfirmTitle: 'Desvincular conta',
  unlinkConfirmMessage: 'Ao desvincular este provedor, o dispositivo voltará ao modo visitante. Seus dados do Hub continuam disponíveis se você logar novamente com o mesmo provedor em outro dispositivo.',
  unlinkConfirmContinue: 'Desvincular',
  unlinkConfirmCancel: 'Cancelar',
  deleteConfirmTitle: 'Confirmar exclusão de conta',
  deleteConfirmMessage: 'Excluir sua conta removerá recordes, dados de login, contas vinculadas e convites.\nEsta ação não pode ser desfeita. Deseja realmente excluir?',
  deleteConfirmContinue: 'Excluir conta',
  deleteConfirmCancel: 'Cancelar',
  adNekoTitle: 'AD Neko',
  matchmakingRemaining: 'Restam {seconds}s',
  matchmakingTimeoutMessage: 'Nenhum oponente encontrado a tempo. Tente novamente.',
  difficultyEasyName: 'Casual',
  difficultyEasyDescription: 'O oponente está um pouco distraído',
  difficultyNormalName: 'Normal',
  difficultyNormalDescription: 'O oponente às vezes comete erros',
  difficultyHardName: 'Difícil',
  difficultyHardDescription: 'O oponente tem uma boa visão do tabuleiro',
  difficultyHellName: 'Extremo',
  difficultyHellDescription: 'O oponente é forte e antecipa jogadas',
}
